// De inrichtingsroute van de actieve club (/api/setup), gedeeld door het menu, het
// dashboard en de pagina Inrichten. Alleen voor wie de club mag inrichten: voor ieder
// ander wordt het { key, unavailable: true }.
import { signal } from '@preact/signals';
import { api, authState } from './auth.js';

export const setup = signal(null); // { key, ...status van de server } of { key, unavailable }
// Telt elke wijziging: een herlaadactie die vóór een wijziging begon, overschrijft die niet
let revision = 0;

const keyOf = () => `${authState.value.userId}:${authState.value.activeClubId}`;

// force: opnieuw ophalen, bijvoorbeeld op het dashboard, waar de teller anders oud blijft
// nadat iemand elders een seizoen of structuur heeft gemaakt
export function loadSetup({ force = false } = {}) {
  const key = keyOf();
  const startedAt = revision;
  if (!force && setup.value?.key === key) return Promise.resolve(setup.value);
  // Na een clubwissel: niet de cijfers van de vorige club laten staan
  if (setup.value && setup.value.key !== key) setup.value = null;
  return api('/api/setup')
    .then(data => ({ key, ...data }), () => ({ key, unavailable: true }))
    .then(value => {
      // Een laat antwoord van een club waar je niet meer in zit, of van vóór een wijziging, telt niet
      if (keyOf() === key && startedAt === revision) setup.value = value;
      return value;
    });
}

// Een antwoord van PUT/POST bevat de nieuwe status: die direct overnemen. key: de club
// waarvoor het verzoek ging; is die niet meer actief, dan telt het antwoord niet.
export function updateSetup(data, key = keyOf()) {
  if (key !== keyOf()) return;
  revision++;
  setup.value = { ...setup.value, ...data, key };
}

// Een wijziging aan de route (afvinken, verbergen, structuur). Eén tegelijk, in volgorde:
// anders kan het antwoord op een eerdere klik dat van een latere overschrijven. De club wordt
// vastgelegd bij de klik; is intussen een andere club actief, dan gaat het verzoek niet meer
// weg en telt een antwoord niet bij de nieuwe club. Een rij per gebruiker en club: een
// verzoek dat blijft hangen, houdt een andere club niet op.
const queues = new Map();
export function changeSetup(path, options) {
  const key = keyOf();
  const request = (queues.get(key) || Promise.resolve())
    .then(() => {
      if (key !== keyOf()) throw new Error('club_changed');
      return api(path, options);
    })
    .then(data => { updateSetup(data, key); return data; });
  const tail = request.catch(() => {});
  queues.set(key, tail);
  // Rij leeg: opruimen, tenzij er intussen een nieuw verzoek achter staat
  tail.then(() => { if (queues.get(key) === tail) queues.delete(key); });
  return request;
}

// Staat de route in menu, dashboard en welkomstvenster: niet af en niet verborgen
export const routeShown = s => !!s && !s.unavailable && s.key === keyOf() && !s.hidden && !s.complete;
